import { DateTime } from 'luxon';

import { loadLuxonDateTime } from '@rygen/rygen-ui/util';

import { ShipmentEventLocation } from '../shipmentEvent/ShipmentEventLocation';
import { ShipmentEventRelatedStopReference } from '../shipmentEvent/ShipmentEventRelatedStopReference';

export class UpdateExpectedArrivalRequest {
  relatedStop?: ShipmentEventRelatedStopReference;
  actualLocation: ShipmentEventLocation = new ShipmentEventLocation();
  expectedArrival?: DateTime;
  comment?: string;

  constructor(opts?: Partial<UpdateExpectedArrivalRequest>) {
    if (opts?.relatedStop != null) {
      this.relatedStop = new ShipmentEventRelatedStopReference(
        opts.relatedStop,
      );
    }
    if (opts?.actualLocation != null) {
      this.actualLocation = new ShipmentEventLocation(opts.actualLocation);
    }
    this.expectedArrival = loadLuxonDateTime(
      opts?.expectedArrival,
      opts?.actualLocation?.timeZone,
    );
    if (opts?.comment != null) {
      this.comment = opts.comment;
    }
  }
}
